/**
 * The glyph on a reset button: the Customizer's per-parameter reset and the
 * Alt View's Lens sliders show the same one, so one picture means one thing.
 *
 * @license GPL-3.0-or-later
 */
export const RESET_GLYPH = '↩';
